<script>
  import MasonryGrid from '../MasonryGrid.svelte';
  import {Link} from "svelte-routing";
</script>

<main>
    <section class="landing-page">
        <div class="landing-header">
            <h1 class="landing-title">One-Stop-Shop</h1>
            <p class="landing-description">Gateway to Genome Engineering Web Tools</p>
        </div>
        <div class="gradient-background"></div>
        <div class="landing-content">
            <MasonryGrid/>
        </div>
    </section>
    <section class="landing-footer">
        <Link to="catalogue" class="button is-rounded is-inverted">Browse Our Catalogue&nbsp;
            <i class="fa fa-arrow-right" aria-hidden="true"></i></Link>
    </section>
</main>

<style>
    .landing-page {
        position: relative;
        padding-top: 50px;
        overflow: hidden;
    }
    .landing-footer {
        text-align: center;
        height: 100px;
    }

    .landing-header {
        text-align: center;
        color: white;
    }

    .landing-title {
        text-transform: uppercase;
        font-size: 1.5em;
        margin-bottom: 20px;
        font-family: 'Oswald', sans-serif;
    }

    .landing-description {
        font-size: 2em;
    }

    .gradient-background {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(to bottom, rgba(10, 10, 10, 0.95) 50%, #f9f9f9 50%);
        z-index: -1;
    }

    .landing-content {
        position: relative;
        background-color: transparent;
        padding: 20px;
        z-index: 1;
    }
</style>
